/* eslint-disable max-len */
import { useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { AddressService } from '../support/services/api/index';

// Get QueryClient from the context

export default function useAddresses(addressableId, addressableType) {
  const queryClient = useQueryClient();
  const [isCreating, setCreating] = useState(false);
  const [isCreated, setCreated] = useState(false);
  const [isError, setError] = useState(false);

  const mutations = {
    removeAddress: useMutation(
      AddressService().deleteAddress,
      { onSuccess: () => queryClient.invalidateQueries('addresses') },
    ),
    addAddresses: useMutation(
      AddressService().createAddress,
      {
        onSuccess: () => queryClient.invalidateQueries('addresses'),
        onError: () => setError(true),
      },
    ),
  };

  const deleteAddress = (addressId) => mutations.removeAddress.mutate(addressId);

  const createAddresses = async (addresses, success) => {
    setCreating(true);
    setCreated(false);
    await mutations.addAddresses.mutateAsync({ addresses, addressableId, addressableType },
      {
        onSuccess: (res) => {
          setCreating(false);
          setCreated(true);
          success(res);
        },
      });
  };

  return {
    commands: {
      deleteAddress,
      createAddresses,
    },
    metaStates: {
      isCreated,
      isCreating,
      isError,
    },
  };
}
